<div class="backModal enMotivo" *ngIf="entrada">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"
      ><span class="cross"></span><span class="sr-only">cerrar</span></a
    >
  </div>
  <div class="aviso">
      <div class="MotivosModalLayout" [class.keyboard-hidden]="isKeyboardHidden">
      <div class="MotivosModalLeft">
        <div class="ticket-info horarios-info">
          <div class="inputControl TicketsPasos">
            <!-- <a href="#" title="Previo" class="prev">
              <img class="svg" src="assets/img/active-arrow.svg" alt="Previo">
            </a> -->
            <span class="titulo"
              >{{ 'MOTIVOS_PARA' | translateV2 }} “{{
                entrada.NombrePantalla
              }}”</span
            >
            <!-- <span class="resumen">Motivos para “Entrada Gratuita”</span> -->
            <!-- <a href="#" title="Próximo" class="next">
              <img class="svg" src="assets/img/active-arrow.svg" alt="Próximo">
            </a> -->
          </div>
        </div>
        <div class="motivosWrap">
          <div class="motivos" *ngIf="motivos; else cargando">
            <div
              class="Rtable-cell motivo-cell"
              (click)="selectMotivo(motivo)"
              [ngClass]="{
                active:
                  getCantidadPorMotivo(motivo.PkId) > 0 &&
                  motivoSeleccionado !== motivo,
                select: motivoSeleccionado === motivo
              }"
              *ngFor="let motivo of motivos"
            >
              <div class="Rtable-cell--content motivo-content">
                {{ motivo.Nombre }}
              </div>
              <div class="Rtable-cell--content motivo-cantidad">
                {{ getCantidadPorMotivo(motivo.PkId) }}
              </div>
              <input
                style="visibility: hidden; display: none"
                id="motivo-{{ motivo.PkId }}"
                type="number"
                class="qty text"
                step="1"
                min="0"
                name="quantity"
                category="MOTIVO"
                (keydown)="inputDeTeclado($event, motivo)"
              />
            </div>
          </div>
        </div>
        <ul class="pagination" style="margin-top: 26px">
          <!-- <li>
            <a href="#" title="Previo">
              <img class="svg" src="assets/img/active-arrow.svg" alt="Previo">
            </a>
          </li>
          <li><a href="#">1</a></li>
          <li><a href="#">2</a></li>
          <li><a href="#">3</a></li>
          <li><a href="#">4</a></li>
          <li><a class="active" href="#">5</a></li>
          <li><a href="#">6</a></li>
          <li>
            <a href="#" title="Próximo">
              <img class="svg" src="assets/img/active-arrow.svg" alt="Próximo">
            </a>
          </li> -->
        </ul>
        <div class="btn-continuar-wrap">
          <a class="SiguienteButton" (click)="close()" title="Principal">
            {{ 'PRINCIPAL' | translateV2 }}
          </a>
        </div>
      </div>
      <div class="MotivosModalRight">
        <section class="col-resumen">
          <fieldset>
            <div class="white-box">
              <div class="Rtable">
                <div class="Rtable-row Rtable-row--head">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell column-heading">
                      {{ 'MOTIVO' | translateV2 }}
                    </div>
                    <div class="Rtable-cell cantidad-cell column-heading">
                      {{ 'CANT' | translateV2 }}
                    </div>
                    <div class="Rtable-cell delete-cell column-heading"></div>
                  </div>
                </div>
                <div class="detailScroll" *ngIf="listaMotivosSeleccionados">
                  <div
                    class="Rtable-row"
                    *ngFor="let motivo of listaMotivosSeleccionados"
                  >
                    <div class="Rtable-row-inner">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">
                          {{ motivo.Nombre }}
                        </div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <input
                              type="number"
                              class="qty text"
                              step="1"
                              min="0"
                              name="quantity"
                              [id]="'motivo-input-' + motivo.PkId"
                              [value]="motivo.numMotivo"
                              title="Cantidad"
                              size="4"
                              (focus)="focusValue($event, motivo)"
                              (keydown)="inputDeTeclado($event, motivo)"
                              (input)="onInputChange($event, motivo)"
                              [attr.category]="'MOTIVO'"
                              [attr.data-motivo-pk-id]="motivo.PkId"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="Rtable-cell delete-cell">
                        <div class="Rtable-cell--content delete-content">
                          <a (click)="eliminarMotivo(motivo)" title="Borrar">
                            <span class="cross"></span>
                            <span class="sr-only">cerrar</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <div class="NumpadWrap" [class.keyboard-hidden]="isKeyboardHidden">
            <div class="totales">
              <div class="titulos">
                <span>{{ 'CANTIDAD' | translate }}</span>
                <span>{{ 'TOTAL' | translate }}</span>
              </div>
              <div class="numeros" *ngIf="listaMotivosSeleccionados">
                <span>{{ getCantidadTotal() }}</span>
                <span
                  >{{
                    getPrecioTotal()
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                </span>
              </div>
            </div>
            <ticketing-numpad [forceShow]="true"></ticketing-numpad>
            <button
              type="button"
              (click)="avanzar()"
              class="pagar descuentos"
            >
              {{ 'SIGUIENTE' | translateV2 }}
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
<ng-template #cargando>
  <div class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
